// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"ec50e187","224":"ec50e187","822":"cbdf33b5"}[chunkId] + ".chunk.css";
};